import { render, staticRenderFns } from "./aFeeDetailDiscount.vue?vue&type=template&id=d6744c3e&scoped=true"
import script from "./aFeeDetailDiscount.vue?vue&type=script&lang=js"
export * from "./aFeeDetailDiscount.vue?vue&type=script&lang=js"
import style0 from "./aFeeDetailDiscount.vue?vue&type=style&index=0&id=d6744c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6744c3e",
  null
  
)

export default component.exports